import React, { useState } from 'react';
import ForwardIcon from '../../../../assets/images/PaymentIcons/ForwardIcon.svg'
import UpwardIcon from '../../../../assets/images/PaymentIcons/UpwardIcon.svg'
export const FrequentAskQuestion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const onItemClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const UpArrowIcon = () => (
    <p><img src={UpwardIcon} alt="" /></p>

  );
  const ForwardArrowIcon = () => (
    <p><img src={ForwardIcon} alt="" /></p>
  );

  const accordionItems = [
    {
      title: 'How soon will my order ship?',
      content: 'Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa. Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa.',
    },
    {
      title: 'Is there any warranty exclusions?',
      content: 'Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa. Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa.',
    },
    {
      title: 'Are there any return exclusions?',
      content: 'Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa. Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa.',
    },
    {
      title: 'Will I be charged for a replacement item?',
      content: 'Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa. Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa.',
    },
    {
      title: 'How can I track my orders & payment?',
      content: 'Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa. Elementum ullamcorper felis nulla scelerisque. Nunc enim nunc mattis leo massa.',
    },

  ];
  return (
    <>
      <div className='max-w-[840px]  mx-auto'>
        <div className="my-4 sm:my-6 py-4 sm:py-6 px-2 text-left rounded-md">
          <div className=" mx-auto">
            <div className="text-center">
              <h3 className="font-bold text-f24 md:text-f36">Frequent ask Question</h3>
              <p className="text-f16 text-secondary">Pellentesque cras adipiscing tempus libero vel nullam mauris tellus. Aliquam ultrices tellus consequat amet, lectus aliquam est in neque.</p>
            </div>
          </div>

          <div className='py-4 sm:py-6'>
            {accordionItems.map((item, index) => (
              <div key={index} className="border-b border-gray-200">
                <button
                  className="w-full flex items-center justify-between p-4 focus:outline-none"
                  onClick={() => onItemClick(index)}
                >
                  <h4 className="text-left font-semibold">{item.title}</h4>
                  <span className='pl-4'>{activeIndex === index ? <UpArrowIcon /> : <ForwardArrowIcon />}</span>
                </button>
                {activeIndex === index && (
                  <div className="p-4">
                    <p>{item.content}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

        </div>
      </div>
    </>
  )
}